export default abstract class ActionCreator<T> {
    constructor(protected fieldValue: string) {}
    abstract getAction: () => (prevState: T) => T;
}
